import { FieldValues, UseFormGetValues, UseFormRegister, UseFormSetValue } from "react-hook-form";
import { Div, Input } from "../../../styles/commonStyle";
import { Flex, RoundButton } from "../../linkAccount/style";
import { FormInput, FormItem, FormLabel } from "../style";


interface EvFormTextProps {
    label: string;
    name: string;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    value?: string;
    register?: UseFormRegister<FieldValues>;
    errors?: any;
    setValue?: UseFormSetValue<FieldValues>;
    getValues?: UseFormGetValues<FieldValues>;
    type?: string;
    placeholder?: string;
    maxLength?: number;
    disabled?: boolean;
    id: string;
    required?: boolean;
    hasCheckButton?: boolean;
    onCheckButtonClick?: () => void;
    validation?: {
        pattern?: {
            value: RegExp;
            message: string;
        };
        validate?: (value: string) => boolean | string;
    };
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
    onInput?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function EvFormText({
    label,
    name,
    onChange,
    value,
    register,
    errors,
    setValue,
    getValues,
    type = 'text',
    placeholder,
    maxLength,
    disabled = false,
    id,
    required = false,
    hasCheckButton = false,
    onCheckButtonClick,
    validation,
    onKeyDown,
    onInput
}: EvFormTextProps) {
    return <FormItem>
        <FormLabel htmlFor={id}>
            {label}<span style={{ color: "#ff8116" }}>{required ? '*' : ''}</span>
        </FormLabel>
        <Flex flexDirection="column" alignItems="start" gap="4px">
            <Flex gap="10px" style={{ width: "100%" }}>
                <Input
                    id={id}
                    style={{ height: "40px" }}
                    type={type}
                    placeholder={placeholder}
                    maxLength={maxLength}
                    {...register!(name, {
                        required: required ? `${label}은(는) 필수입니다` : false,
                        ...validation,
                        maxLength: maxLength ? {
                            value: maxLength,
                            message: `${maxLength}자 이하로 입력해주세요`
                        } : undefined
                    })}
                    onKeyDown={onKeyDown ?? undefined}
                    onInput={onInput ?? undefined}
                    disabled={disabled}
                    borderRadius="0.375rem" />
                {hasCheckButton && (
                    <RoundButton type="button" onClick={onCheckButtonClick}>
                        중복확인
                    </RoundButton>
                )}
            </Flex>
            {errors && <Div style={{ color: "red", fontSize: "14px" }}>{errors.message}</Div>}
        </Flex>
    </FormItem>;
}


interface EvFormPhoneProps {
    label: string;
    phoneValue0: string;
    phoneValue1: string;
    phoneValue2: string;
    id: string;
    required?: boolean;
}

export const EvFormPhone = ({ label, phoneValue0, phoneValue1, phoneValue2, id, required }: EvFormPhoneProps) => {
    return <FormItem>
        <FormLabel htmlFor={id}>
            {label}<span style={{ color: "#ff8116" }}>{required ? '*' : ''}</span>
        </FormLabel>
        <Flex gap="6px">
            <Input
                style={{ height: "40px" }}
                type="text"
                value={phoneValue0}
                disabled
                borderRadius="0.375rem" />
            -
            <Input
                style={{ height: "40px" }}
                type="text"
                value={phoneValue1}
                disabled
                borderRadius="0.375rem" />
            -
            <Input
                style={{ height: "40px" }}
                type="text"
                value={phoneValue2}
                disabled
                borderRadius="0.375rem" />
        </Flex>
    </FormItem>;
}
